export const replaceEntity = (html, search, replacement) =>
  html.replace(new RegExp(search, 'g'), replacement);

export const fixHtml = html => {
  const div = document.createElement('div');
  div.innerHTML = html;
  return div.innerHTML;
};

export const convertRawHtml = rawHtml => {
  if (!rawHtml) {
    return rawHtml;
  }

  let html = replaceEntity(rawHtml, '&amp;', '&');
  html = replaceEntity(html, '&lt;', '<');
  html = replaceEntity(html, '&gt;', '>');
  html = replaceEntity(html, '&quot;', '"');

  return html;
};
